export const miniCartState = ({ data, component } = {}) => {
  if (!data) {
    return false;
  }

  return {
    data: {
      ...data.cart,
    },
    component,
  };
};
